import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { storagePathService } from '../../services/storage-path.service'
import { StoragePath } from '../../types'
import { ManagementList } from '../common/ManagementList'
import { StoragePathEditDialog } from './StoragePathEditDialog'
import { StoragePathVisualizationDialog } from './StoragePathVisualizationDialog'

export const StoragePathList: React.FC = () => {
  const { t } = useTranslation()
  const [showVisualizationDialog, setShowVisualizationDialog] = useState(false)

  const getDeleteMessage = (object: StoragePath) => {
    return t('confirm_delete_storage_path', { name: object.name }) || `Da li stvarno želite da obrišete Fasciklu "${object.name}"?`
  }

  return (
    <>
      <ManagementList
        service={storagePathService}
        editDialogComponent={StoragePathEditDialog}
        typeName={t('storage_path')}
        typeNamePlural={t('storage_paths')}
        permissionType="storage_paths"
        extraColumns={[
          {
            key: 'path',
            name: t('path'),
            hideOnMobile: true,
            monospace: true,
            valueFn: (storagePath: StoragePath) => {
              const path = storagePath.path || ''
              return path.length > 50 ? `${path.slice(0, 49)}...` : path
            },
          },
        ]}
        getDeleteMessage={getDeleteMessage}
        info={t('storage_paths_info')}
        infoLink="storage_paths"
        headerActions={
          <button
            type="button"
            className="btn btn-sm btn-outline-info me-2"
            onClick={() => setShowVisualizationDialog(true)}
            title={t('storage_path_visualization')}
          >
            <i className="bi bi-diagram-3"></i>
          </button>
        }
      />
      {showVisualizationDialog && <StoragePathVisualizationDialog onClose={() => setShowVisualizationDialog(false)} />}
    </>
  )
}
